import type {IHttpResponse, IPromise} from 'angular';
import type {ActionResponse} from 'typings/portaro.be.types';
import {createPayloadActionResponse} from '../modal-utils';

export default class PasswordQuestionModalController {
    public static controllerName = 'PasswordQuestionModalController';

    private submitPromise: (promise: IPromise<ActionResponse | IHttpResponse<ActionResponse>> | Promise<ActionResponse>) => any;

    public init(submitPromise: (promise: IPromise<ActionResponse | IHttpResponse<ActionResponse>> | Promise<ActionResponse>) => any): void {
        this.submitPromise = submitPromise;
    }

    public submitPassword(password: string) {
        this.submitPromise(Promise.resolve(createPayloadActionResponse(password)));
    }
}

export interface PasswordQuestionModalModel {
    text: string;
}
